import { Component, HostListener, OnInit, Renderer2, ViewChild} from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { WarningTermsPolityComponent } from 'src/app/components/modals/warning-terms-polity/warning-terms-polity.component';
import { CONSTANTS } from './../../shared/constants';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonsService } from 'src/app/services/commons.service';
import { SigninService } from 'src/app/services/signin.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { EntitiesService } from 'src/app/services/entities.service';
import { ReCaptchaV3Service } from 'ngx-captcha';
import { trigger, style, animate, transition } from '@angular/animations';
import { TestService } from 'src/app/services/test.service';
import { WarningLoginComponent } from 'src/app/components/modals/warning-login/warning-login.component';
import { RapidErrorComponent } from 'src/app/components/modals/rapid-error/rapid-error.component';
import { LanguageSelectorComponent } from 'src/app/language-selector/language-selector.component';
import { DialogService } from 'primeng/dynamicdialog';
import { LanguageSelectorBeComponent } from 'src/app/language-selector-be/language-selector-be.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  standalone: false,
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss'],
  animations: [
    trigger('fade', [
      transition('void => *', [
        style({ opacity: 0 }),
        animate(1300, style({ opacity: 1 }))
      ])
    ])
  ]
})
export class TermsAndConditionsComponent implements OnInit {
  @ViewChild(LanguageSelectorComponent) languageSelector: LanguageSelectorComponent;

  callTest = false;
  activatedTest = false;
  showProgress = true;
  termsForm: UntypedFormGroup;
  valid = false;
  show = true;
  video: HTMLVideoElement;
  pause = true;
  country: string;
  language: string;
  key: string;
  captcha = false;
  tokenCaptcha: string;
  params = [];
  hiddeCommercialConditions = true;
  showIcon: any = 1;
  checkedTerms: boolean;
  codePetition = '';
  scf = false;
  isRapidScore = false;
  showModal = false;

  constructor(private formBuilder: UntypedFormBuilder,
    public translate: TranslateService,
    private readonly modal: MatDialog,
    private route: Router,
    private paramsHome: ActivatedRoute,
    private readonly commonService: CommonsService,
    private readonly serviceAuthen: AuthenticationService,
    private readonly serviceEntities: EntitiesService,
    private readonly recaptcha: ReCaptchaV3Service,
    private readonly renderer: Renderer2,
    private readonly testService: TestService,
    private readonly activatedRoute: ActivatedRoute,
    private sign: SigninService,
    private dialogService: DialogService,
  ) {

  }

  ngOnInit() {
    this.language = sessionStorage.getItem('language');
    this.country = sessionStorage.getItem('country') || 'ES';
    this.codePetition = this.activatedRoute.snapshot.queryParams.v2 || '';
    this.scf = this.activatedRoute.snapshot.queryParams.scf;
    this.getParamsURL();
    this.renderer.listen(document, 'keydown.control.shift.k', () => {
      const par = sessionStorage.getItem('getParams') || '[]';
      const paramsUrl = JSON.parse(par);
      if (!this.callTest && (paramsUrl[0] === '3' || paramsUrl[0] === '4' )) {
        this.callTest = true;
        this.showProgress = false;
        this.testService.getTests().subscribe((data: any) => {
          this.showProgress = true;
          if (data.start) {
            this.activatedTest = true;
          }
        }, () => this.showProgress = true);
      }

    })
    sessionStorage.removeItem('login_polity');
    this.getKey();
    this.commonService.reloadOTBanner();
    this.commonService.clearDup();
    this.commonService.firstChargePage('Terms', 'Aceptacion de terminos y condiciones', 'funnel');
    this.commonService.eventsAnalitics('visit screen', 'content', 'Terms');
    if (!this.termsForm) {
      this.termsForm = this.formBuilder.group({
        termsAndConditions: new UntypedFormControl({ value: this.readTermsAndConditions(), disabled: this.checkedTerms }, [Validators.required]),
        recaptcha: new UntypedFormControl(false, [Validators.required]),
        ofers: new UntypedFormControl(this.readOfers(), [])
      }, {});
    }
    this.formValidation();
  }

  agreeTerms() {
    this.commonService.eventsAnalitics('click', 'Aceptar terminos y condiciones de uso', 'terms');
  }

  /**
   * lee si hay algun termino y c
   */
  readTermsAndConditions() {
    if (sessionStorage.getItem('terms') && sessionStorage.getItem('polity')) {
      this.checkedTerms = false;
      return true;
    } else {
      this.checkedTerms = true;
      return false;
    }
  }

  openWarmModal() {
    if (this.readTermsAndConditions()) {
      this.commonService.eventsAnalitics('click', 'Aceptar terminos y condiciones de uso', 'terms');
      return;
    } else {
      const modalConfig = new MatDialogConfig();
      modalConfig.width = '590px';
      modalConfig.data = {rapidScore: this.isRapidScore}
      modalConfig.id = this.isRapidScore ? 'modal-info-rapidScore': 'modal-info';
      modalConfig.maxWidth = '590px';
      this.modal.open(WarningTermsPolityComponent, modalConfig);
      this.checkedTerms = true;
    }
  }

  /**
   * lee si hay ofertas
   */
  readOfers() {
    if (sessionStorage.getItem('ofers') && JSON.parse(sessionStorage.getItem('ofers'))) {
      return true;
    } else {
      return false;
    }
  }

  goToHome(check) {
    if (!check) {
      return;
    }
    this.commonService.finishSession();
    this.commonService.eventsAnalitics('click', 'HOME', 'terms');
    this.route.navigateByUrl('/home');
  }

  analiticsGoogle = () => {
    if (!this.termsForm.get('ofers').value) {
      this.commonService.eventsAnalitics('click', 'Aceptar ofertas y promociones', 'terms');
      sessionStorage.setItem('ofers', JSON.stringify(!this.termsForm.get('ofers').value));
    } else {
      sessionStorage.removeItem('ofers');
    }
  }

  saveUrl() {
    this.commonService.setCurrentUrl(this.route.url);
    this.commonService.eventsAnalitics('click', 'FAQs', 'terms');
    this.route.navigateByUrl('faqs');
  }

  /**
   * recoge parametros en funcion desde donde sea llamado
   */
  getParamsURL() {
    let params = '';
    let url = window.location.href;
    let ss = sessionStorage;
    const v = ss.getItem('auxParam') ? JSON.parse(ss.getItem('auxParam')) : '';
    const checkDatanicals = url.includes('utm');

    if (url.includes('v1') || url.includes('v2') || url.includes('v3') || v) {
      if (v) {
        ss.setItem('getParams', JSON.stringify(v));
        params = '?v1=' + v[0];
        params = params + '&v2=' + v[1];
        if (v[2] !== '0') {
          params = params + '&v3=' + v[2];
        } else {
          params = params + '&v3=0';
        }
        url = url + params;
      }

      let aux = url.split('?v1=')[1];
      this.params.push(aux.substr(0, aux.indexOf('&v2')));
      const a = aux.substr(0, aux.indexOf('&v2'));
      this.hiddeCommercialConditions = (a === '3' || a === '4') ? false : true;

      aux = url.split('&v2=')[1];
      if (aux.includes('&v3=')) {
        this.params.push(aux.substr(0, aux.indexOf('&v3=')));
      } else {
        this.params.push(aux.substr(0, aux.includes('&utm') ? aux.indexOf('&utm') : aux.length));
      }

      if (checkDatanicals) {
        this.getDatanicalsParams(aux, true);
      }

      aux = url.split('&v3=')[1];
      if (aux && aux !== '0') {
        if (url.includes('&utm')) {
          this.params.push(aux.substr(0, aux.includes('&utm') ? aux.indexOf('&utm') : aux.length));
        } else {
          this.params.push(aux);
        }
      } else {
        this.params.push('0');
      }
      ss.setItem('getParams', JSON.stringify(this.params));
      if (this.params[0] === '2' && !ss.getItem('_hc')) {
        ss.setItem('_hc', '1');
        this.route.navigateByUrl('/startpage');
      }

    } else if (checkDatanicals) {
      this.getDatanicalsParams(url, false);
    } else {
      if (!this.termsForm) {
        this.termsForm = this.formBuilder.group({
          termsAndConditions: new UntypedFormControl({ value: this.readTermsAndConditions(), disabled: this.checkedTerms }, [Validators.required]),
          recaptcha: new UntypedFormControl(false, [Validators.required]),
          ofers: new UntypedFormControl(this.readOfers(), [])
        }, {});
      }
      this.addEmail();
      if (this.termsForm.controls.email) {
        this.route.navigateByUrl('/home');
      }
      ss.setItem('getParams', null);
    }
    this.showIconConsumer();
  }


  getDatanicalsParams(url, interrogation) {
    const datanicalsParams = [];
    let aux = '';
    if (interrogation) {
      aux = url.split('&');
      for (const i of aux) {
        if (i.includes('utm')) {
          datanicalsParams.push({
            name: i.split('=')[0],
            value: i.split('=')[1]
          });
        }
      }
    } else {
      aux = url.split('?')[1].split('&');
      for (const i of aux) {
        datanicalsParams.push({
          name: i.split('=')[0],
          value: i.split('=')[1]
        });
      }
    }
    sessionStorage.setItem('datanicalsParams', JSON.stringify(datanicalsParams));
    return url;
  }

  /**
   * muestra icono de consumer
   */
  showIconConsumer() {
    const v = JSON.parse(sessionStorage.getItem('getParams'));
    this.showIcon = v ? v[0] : 1;
    this.isRapidScore = this.showIcon !== 1;
  }


  /**
   * get captcha key
   */
  getKey() {
    if (!sessionStorage.getItem('k_ca')) {
      this.serviceAuthen.getCaptchaKey(this.codePetition).subscribe((key: any) => {
        sessionStorage.setItem('k_ca', key.gsv || key);
        sessionStorage.setItem('country', key.Country);
        this.country = key.Country;
        const v = JSON.parse(sessionStorage.getItem('getParams'));
        if (v[0]==="4") {
          sessionStorage.setItem('language', key.Language);
          this.language = key.Language;
          if(this.country === 'BE') {
            this.languageSelector.changeLanguage('en_UK');
            if (this.country === 'BE' && !localStorage.getItem('selectedLanguage')) {
              const ref = this.dialogService.open(
                LanguageSelectorBeComponent, {
                  width: '700px',
                  dismissableMask: false,
                  baseZIndex: 10000,
                  closable: false,
                  modal: true
              });
        
              ref.onClose.subscribe(() => {
                this.languageSelector.changeLanguage(sessionStorage.getItem('language') || 'en_UK');
              });
            }
          }
          else{
            this.languageSelector.changeLanguage(key.Language);
          }
       }

        this.key = key.gsv || key;
        if (this.isRapidScore && !key.Ok && key.Message) {
          const modalConfig = new MatDialogConfig();
          modalConfig.data = { text: key.Message, hideAccept: true };
          modalConfig.disableClose = true;
          modalConfig.id = this.isRapidScore ? 'modal-info-rapidScore' : 'modal-info';
          modalConfig.maxWidth = '590px';
          this.modal.open(RapidErrorComponent, modalConfig);
          sessionStorage.clear();
        }
        if (!sessionStorage.getItem('tyc') && key.tyc) {
          sessionStorage.setItem('tyc', key.tyc);
        }
      });
    } else {
      this.key = sessionStorage.getItem('k_ca');
    }
  }

  /**
   * retorna una validacion para mostrar mensaje de error
   */
  validations(): boolean {
    if (this.termsForm.controls.email) {
      return this.termsForm.controls.email.value && this.termsForm.invalid && this.termsForm.controls.email.touched ||
        !this.termsForm.controls.email.value && this.termsForm.controls.email.touched;
    }
  }

  /**
   * comprueba si es valido el formulario
   */
  formValidation() {
    this.valid = this.termsForm.get('termsAndConditions').value;
    this.termsForm.valueChanges.subscribe(data => {
      this.valid = data.termsAndConditions;
      if (data.email && !CONSTANTS.REG_EXP_MAIL.test(data.email) || data.email && !this.termsForm.get('email').value) {
        this.termsForm.setErrors({ emailInvalid: true });
      } else {
        sessionStorage.setItem('email', data.email);
        this.termsForm.setErrors(null);
      }
    });
  }

  /**
   * envia el formulario cuando es valido
   */
  onSubmit() {
    if (this.termsForm.valid) {
      if (sessionStorage.getItem('signSCF')) {
        this.serviceEntities.getTink().subscribe(data => window.location.href = data);
        // this.route.navigateByUrl('/login');
      } else {
        this.recaptcha.execute(this.key, 'login', (token) => {
          this.showProgress = false;
          this.successCaptcha(token);
        }, { useGlobalDomain: true });
      }

    }
  }

  successCaptcha(event) {
    // if (this.activatedTest) {
    //   this.route.navigateByUrl('/test');
    //   return;
    // }
    if (this.scf) {
      // Llamar al servicio de tyc para SCF
      this.serviceAuthen.saveTyC({
        TyCS: this.termsForm.get('termsAndConditions').value,
        PolPri: this.termsForm.get('ofers').value || false
      }).subscribe(() => {
        const token = sessionStorage.getItem('t');
        this.serviceEntities.getEntities(token).subscribe(d => {
          this.commonService.setEntities(d.banks);
          sessionStorage.removeItem('email');
          this.commonService.finishSession();
          this.commonService.eventsAnalitics('conversion', 'Terminos y condiciones aceptados', 'OK');
          sessionStorage.removeItem('signinSCF');
          if (this.activatedTest) {
            this.route.navigateByUrl('/test');
          } else {
            if (sessionStorage.getItem('globalSCF')) {
              this.sign.globalPosition(token).subscribe((c: any) => {
                sessionStorage.removeItem('globalSCF')
                sessionStorage.setItem('t', c.Token);
                sessionStorage.setItem('_k', this.commonService.encrypt(c));
                sessionStorage.removeItem('signinSCF');
                this.commonService.setKpi(c);
                this.commonService.eventsAnalitics('conversion', 'Informe recuperado correctamente', 'signin');
                this.route.navigateByUrl('global-position');
              });
            } else {
              this.serviceEntities.getTink(token).subscribe(data => window.location.href = data);
        // this.route.navigateByUrl('/login');
            }
          }
        }, error => {
          this.showProgress = true;
        });
      });

    } else {
      this.serviceAuthen.getAuthentication(this.termsForm, event, this.params).subscribe((data: any) => {
        sessionStorage.setItem('t', data.Token);
        sessionStorage.setItem('hash-datanicals', data.Hash);
        sessionStorage.setItem('Channel', data.OB_Channel);
        if (this.params[2] === '1' || this.params[2] === '2') {
          this.engagementRedirect(data);
          return;
        }

        if (data && data.Message !== 'OK') {
          this.showProgress = true;
          return;
        }
        this.serviceEntities.getEntities(sessionStorage.getItem('t')).subscribe(d => {
          this.commonService.setEntities(d.banks);
          sessionStorage.removeItem('email');
          this.commonService.finishSession();
          this.commonService.eventsAnalitics('conversion', 'Terminos y condiciones aceptados', 'OK');
          if (this.activatedTest) {
            this.route.navigateByUrl('/test');
          } else {
            this.route.navigateByUrl('/login');
            // this.serviceEntities.getTink(data.Token).subscribe(data => window.location.href = data);
          }
        }, error => {
          this.showProgress = true;
        });
      });
    }

  }

  /**
   * se encarga de redirigir a contratación
   * @param data objeto respuesta del servicio
   */
  engagementRedirect(data) {
    if ((data.Message === 'KO' || data.Message === 'OK') && data.Hash.includes('http')) {
      this.commonService.setKpi(
        this.commonService.encrypt({
          URL: data.Hash,
          Success: data.Message === 'KO' ? false : true
        })
      );
      sessionStorage.setItem('_k_engagement',
        this.commonService.encrypt({ URL: data.Hash, Success: data.Message === 'KO' ? false : true }));
      this.route.navigateByUrl('engagement');
    }
  }

  expireCaptcha() {
    this.captcha = false;
  }

  resetCaptcha() {
    this.captcha = false;
  }

  /**
   * direcciona a la url pasada por parametro
   * @param url: string
   */
  navigateToUrl(url) {
    if(url === 'terms-conditions') {
      url = (this.country) + '/' + (url);
    }
    else if(url === 'privacy-polity') {
      url = (this.country) + '/' + (url);
    }
    this.commonService.eventsAnalitics('click', window.location.origin + '/FRONT' + url, '/terms');
    sessionStorage.setItem('current_view', '/' + url);
    this.commonService.setCurrentUrl(this.route.url, { show: true });
    this.route.navigateByUrl(url);
  }

  /**
   * Añade email de manera dinamica
   */
  private addEmail() {
    if (!this.scf) {
      //Redireccion a home para invitados
      // this.route.navigateByUrl('/home');
      // return;
      const e = sessionStorage.getItem('email');
      this.termsForm.addControl('email', new UntypedFormControl(e ? e : '', [Validators.email, Validators.required]));
      this.validations();
    }
  }
}
